import {
  adults_only_rising_position,
  adults_only_back_position,
  adults_only_normal_position,
  adults_only_side_position,
  adults_only_curved_position,
  adults_only_cross_position,
  adults_only_seating_position,
  adults_only_standing_position,
  adults_only_fellatio,
  adults_only_cunnilingus,
  adults_only_fingering,
  adults_only_position_69,
  adults_only_female_masturbation,
  adults_only_male_masturbation,
  adults_only_paizuri,
  adults_only_undressing_shower,
  adults_only_threesome_orgy,
  adults_only_bdsm,
  adults_only_foreplay,
  adults_only_erection,
  adults_only_kiss,
  adults_only_female_body_emphasis,
  EyeGray400,
  EyeCrossLineWhite,
  radio_selected,
  radio_unselected
} from '@assets/icons';
import {
  Chip,
  MenuTop,
  Output,
  RadioItem,
  TagSearchBar,
  Text,
  Select,
  SearchResetButton,
  CheckboxItem,
  TagSearchInput,
  SimpleCharacterNumberInput
} from '@components';
import {
  ChipPaperType,
  FemaleBodyChildOptionValueEnum,
  SexualBodyPartChildOptionValueEnum,
  SexualPositionChildOptionValueEnum,
  OutputSortTypeEnum,
  styleConstant,
  AdultsOnlyGenreValueEnum,
  FrameChildOptionValueEnum,
  HorizontalAngleChildOptionValueEnum,
  VerticalAngleChildOptionValueEnum,
  SelectedComicOptionEnum
} from '@constant';
import { RadioGroup, MenuItem, Radio } from '@mui/material';
import { useComic, useAdultsOnlyOutput, useOutput } from '@hooks';
import { colorSet } from '@theme';
import { useCallback, useEffect, useState } from 'react';
import { useAdultsOnlyActions, useComicActions } from '@remote-hooks';
import { throttle } from 'lodash';

const AdultsOnlyOutputPage = () => {
  const {
    selectedOption,
    handleOptionChange,
    selectedGenreList,
    handleGenreToggle,
    isGenreSelected,
    selectedComicNameList,
    inputKeyword,
    autocompleteList,
    handleKeyDown,
    handleInputKeywordChange,
    handleAutocompleteChange,
    handleComicTagClear
  } = useComic();

  const {
    characterNumber,
    selectedMetaTags,
    tagInputKeyword,
    handleTagKeyDown,
    handleTagInputKeywordChange,
    tagAutocompleteList,
    handleTagAutocompleteChange,
    handleSingleTagClear,
    handleTagClear,
    handleTagSubmit
  } = useAdultsOnlyOutput();

  const {
    data,
    storedAdultsOnlyChildOptionValue,
    onSetAdultsOnly,
    handleIncludeUsedToggle,
    handleIncludeOtherUsersUsedToggle
  } = useOutput();

  // 스크롤다운에 따른 layout 분기용 state
  const [isScrollDown, setIsScrollDown] = useState<boolean>(false);
  // 마운트 상태를 추적하는 state
  const [isComponentMounted, setIsComponentMounted] = useState(false);

  const { onInitComic } = useComicActions();
  const { onInitAdultsOnly } = useAdultsOnlyActions();

  // AdultsOnlyGenreValueEnum의 값들을 배열로 변환
  const genreOptions = Object.values(AdultsOnlyGenreValueEnum);

  // 정렬 기준 Select 컴포넌트의 value를 영어가 아닌 한국어로 보여주기 위한 변수
  const SORT_LABELS: Record<OutputSortTypeEnum, string> = {
    [OutputSortTypeEnum.RANDOM]: '랜덤순',
    [OutputSortTypeEnum.LOW_USAGE]: '사용량 낮음'
  };

  // Throttled scroll handler
  const handleScroll = useCallback(
    throttle(() => {
      if (window.scrollY > styleConstant.topPageNameHeight) {
        setIsScrollDown(true);
      } else {
        setIsScrollDown(false);
      }
    }, 200), // 200ms 간격으로 호출되도록 설정
    []
  );

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    setIsComponentMounted(true);
    if (!isComponentMounted) return;

    return () => {
      onInitComic();
      onInitAdultsOnly();
    };
  }, [isComponentMounted, onInitComic, onInitAdultsOnly]);

  return (
    <div id="adults-only-output-id" style={{ display: 'flex', flexDirection: 'column' }}>
      <MenuTop pageName={isScrollDown ? '19금' : undefined} />

      {/* 상단: 페이지 타이틀 & 장르 및 작품명 */}
      <div
        className="topFilter"
        style={{
          backgroundColor: colorSet.white,
          height: 24 + 132, // paddingTop + frame height
          padding: '0px 40px',
          display: 'flex',
          alignItems: 'flex-end'
        }}
      >
        <div style={{ width: '100%' }}>
          {isScrollDown ? null : (
            <Text variant="h2" fontWeight="bold" marginBottom="24px">
              19금
            </Text>
          )}

          <div style={{ display: 'flex', flexDirection: 'row', gap: '24px' }}>
            {/* 검색 옵션: 장르 */}
            <div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '8px' }}>
                <Radio
                  checked={selectedOption === SelectedComicOptionEnum.GENRE}
                  onChange={() => handleOptionChange(SelectedComicOptionEnum.GENRE)}
                  checkedIcon={<img src={radio_selected} alt="" style={{ width: 20, height: 20 }} />}
                  icon={<img src={radio_unselected} alt="" style={{ width: 20, height: 20 }} />}
                />
                <Text variant="subtitle" fontWeight="bold">
                  장르
                </Text>
              </div>

              <Select
                disabled={selectedOption !== SelectedComicOptionEnum.GENRE}
                multiple={true}
                value={selectedGenreList}
                renderValue={(selected: any) => {
                  if (selected && selected.length > 0) {
                    return selected.join(', ');
                  } else {
                    return (
                      <Text variant="body1" color={colorSet.gray400}>
                        {selectedOption !== SelectedComicOptionEnum.GENRE
                          ? '작품명 입력 시 장르는 자동 선택됩니다.'
                          : '장르를 1개 이상 선택해주세요.'}
                      </Text>
                    );
                  }
                }}
                boxstyle={{ width: 344 }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 386,
                      '&::-webkit-scrollbar': {
                        width: '8px',
                        height: '0px'
                      },
                      '&::-webkit-scrollbar-thumb': {
                        borderRadius: '8px',
                        backgroundColor: colorSet.primaryMain
                      },
                      '&::-webkit-scrollbar-track': {
                        borderRadius: '8px',
                        backgroundColor: colorSet.gray200
                      },
                      '& .MuiMenuItem-root.Mui-selected': {
                        backgroundColor: colorSet.white
                      }
                    }
                  }
                }}
              >
                <MenuItem value={''} disabled>
                  장르
                </MenuItem>
                {genreOptions.map((genre) => (
                  <MenuItem key={genre} value={genre} onClick={() => handleGenreToggle(genre)}>
                    <CheckboxItem
                      label={genre}
                      isChecked={isGenreSelected(genre)}
                      onChange={() => handleGenreToggle(genre)}
                    />
                  </MenuItem>
                ))}
              </Select>
            </div>

            {/* 검색 옵션: 작품명 */}
            <div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '8px' }}>
                <Radio
                  checked={selectedOption === SelectedComicOptionEnum.COMIC_NAME}
                  onChange={() => handleOptionChange(SelectedComicOptionEnum.COMIC_NAME)}
                  checkedIcon={<img src={radio_selected} alt="" style={{ width: 20, height: 20 }} />}
                  icon={<img src={radio_unselected} alt="" style={{ width: 20, height: 20 }} />}
                />
                <Text variant="subtitle" fontWeight="bold">
                  작품명
                </Text>
              </div>

              <TagSearchInput
                placeholder={
                  selectedOption !== SelectedComicOptionEnum.COMIC_NAME
                    ? '장르 선택 시 해당 장르의 작품이 전체 검색됩니다.'
                    : '작품명 입력 후 엔터를 누르세요.'
                }
                tags={selectedComicNameList}
                inputValue={inputKeyword}
                options={autocompleteList}
                onKeyDown={handleKeyDown}
                onInputChange={handleInputKeywordChange}
                onAutocompleteChange={handleAutocompleteChange}
                onTagClear={handleComicTagClear}
                disabled={selectedOption !== SelectedComicOptionEnum.COMIC_NAME}
                boxstyle={{ width: 344 }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* 상단: 필터 초기화 & Chip & 태그 검색 인풋 */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          gap: '20px', // Chip 영역과 TagSearchBar 영역 사이의 간격
          width: '100%', // 전체 너비를 사용하도록 명시
          position: 'sticky',
          top: styleConstant.menuTopHeight,
          backgroundColor: colorSet.white,
          borderBottom: `1px solid ${colorSet.gray300}`,
          padding: '24px 40px',
          zIndex: styleConstant.zIndexTopFilter
        }}
      >
        <div style={{ flex: 1 }}>
          <SearchResetButton boxstyle={{ marginBottom: '12px' }} />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: `12px`, width: '100%', boxSizing: 'border-box' }}>
            <Chip
              label="여체"
              paperType={ChipPaperType.CHECKBOX_LIST}
              options={{
                슬랜더: { name: '슬랜더', value: FemaleBodyChildOptionValueEnum['슬랜더'], isSelected: false },
                글래머: { name: '글래머', value: FemaleBodyChildOptionValueEnum['글래머'], isSelected: false },
                슈퍼글래머: {
                  name: '슈퍼글래머',
                  value: FemaleBodyChildOptionValueEnum['슈퍼글래머'],
                  isSelected: false
                },
                통통: { name: '통통', value: FemaleBodyChildOptionValueEnum['통통'], isSelected: false }
              }}
              storedChildOptionValue={storedAdultsOnlyChildOptionValue.femaleBody}
              setSelectedOption={(param) => {
                onSetAdultsOnly({ femaleBody: param });
              }}
            />
            <Chip
              label="신체 부위"
              paperType={ChipPaperType.CHECKBOX_LIST}
              options={{
                가슴: { name: '가슴', value: SexualBodyPartChildOptionValueEnum['가슴'], isSelected: false },
                엉덩이: { name: '엉덩이', value: SexualBodyPartChildOptionValueEnum['엉덩이'], isSelected: false },
                '여자 성기': {
                  name: '여자 성기',
                  value: SexualBodyPartChildOptionValueEnum['여자 성기'],
                  isSelected: false
                },
                '남자 성기': {
                  name: '남자 성기',
                  value: SexualBodyPartChildOptionValueEnum['남자 성기'],
                  isSelected: false
                },
                입: {
                  name: '입',
                  value: SexualBodyPartChildOptionValueEnum['입'],
                  isSelected: false
                },
                얼굴: {
                  name: '얼굴',
                  value: SexualBodyPartChildOptionValueEnum['얼굴'],
                  isSelected: false
                }
              }}
              storedChildOptionValue={storedAdultsOnlyChildOptionValue.sexualBodyPart}
              setSelectedOption={(param) => {
                onSetAdultsOnly({ sexualBodyPart: param });
              }}
            />
            <SimpleCharacterNumberInput
              characterNumber={characterNumber}
              onApplyClick={(values: { maleNumber: number; femaleNumber: number }) => {
                onSetAdultsOnly({ characterNumber: values });
              }}
              onChipXButtonClick={() => {
                onSetAdultsOnly({ characterNumber: null });
              }}
            />
            <Chip
              label="프레임"
              paperType={ChipPaperType.CHECKBOX_LIST}
              options={{
                클로즈업: {
                  name: '클로즈업',
                  value: FrameChildOptionValueEnum['클로즈업'],
                  isSelected: false
                },
                미디엄샷: {
                  name: '미디엄샷',
                  value: FrameChildOptionValueEnum['미디엄샷'],
                  isSelected: false
                },
                풀샷: {
                  name: '풀샷',
                  value: FrameChildOptionValueEnum['풀샷'],
                  isSelected: false
                }
              }}
              storedChildOptionValue={storedAdultsOnlyChildOptionValue.frame}
              setSelectedOption={(param) => {
                onSetAdultsOnly({ frame: param });
              }}
            />
            <Chip
              label="가로앵글"
              paperType={ChipPaperType.CHECKBOX_LIST}
              options={{
                정면: { name: '정면', value: HorizontalAngleChildOptionValueEnum['정면'], isSelected: false },
                정측면: {
                  name: '정측면',
                  value: HorizontalAngleChildOptionValueEnum['정측면'],
                  isSelected: false
                },
                측면: { name: '측면', value: HorizontalAngleChildOptionValueEnum['측면'], isSelected: false },
                후측면: {
                  name: '후측면',
                  value: HorizontalAngleChildOptionValueEnum['후측면'],
                  isSelected: false
                },
                후면: { name: '후면', value: HorizontalAngleChildOptionValueEnum['후면'], isSelected: false }
              }}
              storedChildOptionValue={storedAdultsOnlyChildOptionValue.angleFirst}
              setSelectedOption={(param) => {
                onSetAdultsOnly({ angleFirst: param });
              }}
            />
            <Chip
              label="세로앵글"
              paperType={ChipPaperType.CHECKBOX_LIST}
              options={{
                로우앵글: {
                  name: '로우앵글',
                  value: VerticalAngleChildOptionValueEnum['로우앵글'],
                  isSelected: false
                },
                하이앵글: {
                  name: '하이앵글',
                  value: VerticalAngleChildOptionValueEnum['하이앵글'],
                  isSelected: false
                },
                항공샷: {
                  name: '항공샷',
                  value: VerticalAngleChildOptionValueEnum['항공샷'],
                  isSelected: false
                },
                평시각: {
                  name: '평시각',
                  value: VerticalAngleChildOptionValueEnum['평시각'],
                  isSelected: false
                }
              }}
              storedChildOptionValue={storedAdultsOnlyChildOptionValue.angleSecond}
              setSelectedOption={(param) => {
                onSetAdultsOnly({ angleSecond: param });
              }}
            />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '20px',
            width: '560px', // TagSearchBar 최대너비(560px)
            minWidth: '240px', // TagSearchBar 최소너비(240px)
            flexShrink: 1 // 필요한 경우 줄어들 수 있도록 설정
          }}
        >
          <div
            style={{
              flex: 1,
              minWidth: '240px', // SearchBar의 최소 너비
              maxWidth: '560px' // SearchBar의 최대 너비
            }}
          >
            <TagSearchBar
              placeholder="태그 입력 후 스페이스바를 누르세요."
              tags={selectedMetaTags}
              inputValue={tagInputKeyword}
              options={tagAutocompleteList}
              onKeyDown={handleTagKeyDown}
              onInputChange={handleTagInputKeywordChange}
              onAutocompleteChange={handleTagAutocompleteChange}
              onTagClear={handleSingleTagClear}
              onClear={handleTagClear}
              onSubmit={handleTagSubmit}
            />
          </div>
        </div>
      </div>

      {/* 하단: 좌측 메뉴 및 검색 결과 */}
      <div style={{ display: 'flex' }}>
        {/* 좌측 메뉴 */}
        <div
          style={{
            width: styleConstant.outputPageLeftMenuWidth,
            padding: '24px 32px 96px 32px',
            backgroundColor: colorSet.gray100,
            borderRight: `1px solid ${colorSet.gray300}`
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text variant="body1" fontWeight="bold">
              체위
            </Text>
            <RadioGroup
              value={storedAdultsOnlyChildOptionValue.sexualPosition}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                onSetAdultsOnly({
                  sexualPosition: event.target.value as SexualPositionChildOptionValueEnum
                });
              }}
            >
              <RadioItem
                label="전체 선택"
                boxstyle={{ cursor: 'pointer', width: 84 }}
                value={SexualPositionChildOptionValueEnum['모든 체위']}
                onChange={(value) => {
                  onSetAdultsOnly({
                    sexualPosition: value as SexualPositionChildOptionValueEnum
                  });
                }}
              />
            </RadioGroup>
          </div>
          <div style={{ width: 224, padding: '8px 0px', marginTop: '8px' }}>
            <RadioGroup
              value={storedAdultsOnlyChildOptionValue.sexualPosition}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                onSetAdultsOnly({
                  sexualPosition: event.target.value as SexualPositionChildOptionValueEnum
                });
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: '24px'
                }}
              >
                <RadioItem
                  label="정상위"
                  value={SexualPositionChildOptionValueEnum['정상위']}
                  image={adults_only_normal_position}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="기승위"
                  value={SexualPositionChildOptionValueEnum['기승위']}
                  image={adults_only_rising_position}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="후배위"
                  value={SexualPositionChildOptionValueEnum['후배위']}
                  image={adults_only_back_position}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="측위"
                  value={SexualPositionChildOptionValueEnum['측위']}
                  image={adults_only_side_position}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="굴곡위"
                  value={SexualPositionChildOptionValueEnum['굴곡위']}
                  image={adults_only_curved_position}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="교차위"
                  value={SexualPositionChildOptionValueEnum['교차위']}
                  image={adults_only_cross_position}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="좌위"
                  value={SexualPositionChildOptionValueEnum['좌위']}
                  image={adults_only_seating_position}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="입위"
                  value={SexualPositionChildOptionValueEnum['입위']}
                  image={adults_only_standing_position}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="펠라치오"
                  value={SexualPositionChildOptionValueEnum['펠라치오']}
                  image={adults_only_fellatio}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="커닐링구스"
                  value={SexualPositionChildOptionValueEnum['커닐링구스']}
                  image={adults_only_cunnilingus}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="핑거링"
                  value={SexualPositionChildOptionValueEnum['핑거링']}
                  image={adults_only_fingering}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="69체위"
                  value={SexualPositionChildOptionValueEnum['69체위']}
                  image={adults_only_position_69}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="여성자위"
                  value={SexualPositionChildOptionValueEnum['여성자위']}
                  image={adults_only_female_masturbation}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="남성자위"
                  value={SexualPositionChildOptionValueEnum['남성자위']}
                  image={adults_only_male_masturbation}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="파이즈리"
                  value={SexualPositionChildOptionValueEnum['파이즈리']}
                  image={adults_only_paizuri}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="탈의/샤워"
                  value={SexualPositionChildOptionValueEnum['탈의/샤워']}
                  image={adults_only_undressing_shower}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="쓰리썸/난교"
                  value={SexualPositionChildOptionValueEnum['쓰리썸/난교']}
                  image={adults_only_threesome_orgy}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="BDSM"
                  value={SexualPositionChildOptionValueEnum['BDSM']}
                  image={adults_only_bdsm}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="애무"
                  value={SexualPositionChildOptionValueEnum['애무']}
                  image={adults_only_foreplay}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="발기"
                  value={SexualPositionChildOptionValueEnum['발기']}
                  image={adults_only_erection}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="키스"
                  value={SexualPositionChildOptionValueEnum['키스']}
                  image={adults_only_kiss}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
                <RadioItem
                  label="여체 강조"
                  value={SexualPositionChildOptionValueEnum['여체 강조']}
                  image={adults_only_female_body_emphasis}
                  imageSize={64}
                  onChange={(value) => {
                    onSetAdultsOnly({
                      sexualPosition: value as SexualPositionChildOptionValueEnum
                    });
                  }}
                />
              </div>
            </RadioGroup>
          </div>
        </div>

        {/* 검색 결과 */}
        <div
          style={{
            width: '100%',
            padding: '48px 40px 96px 40px'
          }}
        >
          {/* 19금 Output페이지 태그 검색시 상단에 선택된 태그들과 검색결과 갯수 */}
          {storedAdultsOnlyChildOptionValue &&
          storedAdultsOnlyChildOptionValue.selectedMetaTags &&
          storedAdultsOnlyChildOptionValue.selectedMetaTags.length > 0 ? (
            <div style={{ display: 'flex', marginBottom: '20px' }}>
              {storedAdultsOnlyChildOptionValue.selectedMetaTags.map((item, index) => {
                if (
                  storedAdultsOnlyChildOptionValue.selectedMetaTags &&
                  index === storedAdultsOnlyChildOptionValue.selectedMetaTags.length - 1
                ) {
                  return (
                    <div key={index} style={{ display: 'flex' }}>
                      <Text variant="h3" fontWeight="bold" color="primary">
                        &apos;{item}&apos;
                      </Text>
                      <Text variant="h3" fontWeight="bold">
                        &nbsp;
                      </Text>
                    </div>
                  );
                } else {
                  return (
                    <div key={index} style={{ display: 'flex' }}>
                      <Text variant="h3" fontWeight="bold" color="primary">
                        &apos;{item}&apos;
                      </Text>
                      <Text variant="h3" fontWeight="bold">
                        ,&nbsp;
                      </Text>
                    </div>
                  );
                }
              })}
              <Text variant="h3" fontWeight="bold">
                태그가 포함된 이미지{' '}
                {data?.pages[0].data.meta?.itemCount ? data?.pages[0].data.meta?.itemCount.toLocaleString() : 0}장
              </Text>
            </div>
          ) : null}

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              marginBottom: '20px'
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: 12
              }}
            >
              <div
                onClick={handleIncludeUsedToggle}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 4,
                  padding: '8px 24px',
                  alignItems: 'center',
                  borderRadius: '22px',
                  border: storedAdultsOnlyChildOptionValue.isIncludeUsed ? `1px solid ${colorSet.gray400}` : 'none',
                  cursor: 'pointer',
                  backgroundColor: storedAdultsOnlyChildOptionValue.isIncludeUsed ? 'transparent' : colorSet.gray600
                }}
              >
                {storedAdultsOnlyChildOptionValue.isIncludeUsed ? <EyeGray400 /> : <EyeCrossLineWhite />}
                <Text
                  variant="body2"
                  color={storedAdultsOnlyChildOptionValue.isIncludeUsed ? colorSet.gray400 : colorSet.white}
                  fontWeight={storedAdultsOnlyChildOptionValue.isIncludeUsed ? 400 : 700}
                >
                  내가 사용한 이미지
                </Text>
              </div>
              <div
                onClick={handleIncludeOtherUsersUsedToggle}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 4,
                  padding: '8px 24px',
                  alignItems: 'center',
                  borderRadius: '22px',
                  border: storedAdultsOnlyChildOptionValue.isIncludeOtherUsersUsed
                    ? `1px solid ${colorSet.gray400}`
                    : 'none',
                  cursor: 'pointer',
                  backgroundColor: storedAdultsOnlyChildOptionValue.isIncludeOtherUsersUsed
                    ? 'transparent'
                    : colorSet.gray600
                }}
              >
                {storedAdultsOnlyChildOptionValue.isIncludeOtherUsersUsed ? <EyeGray400 /> : <EyeCrossLineWhite />}
                <Text
                  variant="body2"
                  color={storedAdultsOnlyChildOptionValue.isIncludeOtherUsersUsed ? colorSet.gray400 : colorSet.white}
                  fontWeight={storedAdultsOnlyChildOptionValue.isIncludeOtherUsersUsed ? 400 : 700}
                >
                  남이 사용한 이미지
                </Text>
              </div>
            </div>
            <Select
              value={storedAdultsOnlyChildOptionValue.sortType}
              renderValue={(value) => {
                const sortType = value as OutputSortTypeEnum;
                return SORT_LABELS[sortType] || '정렬 기준';
              }}
              onChange={(e) => {
                onSetAdultsOnly({ sortType: e.target.value });
              }}
              boxstyle={{ width: 160 }}
            >
              <MenuItem value={''} disabled>
                정렬 기준
              </MenuItem>
              <MenuItem value={OutputSortTypeEnum.RANDOM}>랜덤순</MenuItem>
              <MenuItem value={OutputSortTypeEnum.LOW_USAGE}>사용량 낮음</MenuItem>
            </Select>
          </div>

          <Output padding="0" />
        </div>
      </div>
    </div>
  );
};

export default AdultsOnlyOutputPage;
